// extracted by mini-css-extract-plugin
export default {"container":"Warnings_View_container__Xlh+z","containerFixed":"Warnings_View_containerFixed__JPE+U","compact":"Warnings_View_compact__DsyZM","toggle":"Warnings_View_toggle__QjXgu"};